const CustomSelectFilter = ({
  options,
  value,
  onChange,
  placeholder,
  selectName,
}) => {
  return (
    <div>
      <label className="sr-only">{placeholder || "Select an option"}</label>

      <div className="flex flex-row bg-white rounded-full h-10 border border-gray-400">
        {selectName && 
        <span className="px-4 h-full border-r border-gray-400 flex items-center text-md
         font-normal text-gray-600">
        {selectName}</span>
        }
        <select
          className="border-0 bg-transparent focus:ring-0 text-sm"
          value={value || ""}
          onChange={(e) => onChange(e.target.value || null)}
        >
          <option value="">{placeholder || "Select an option"}</option>
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default CustomSelectFilter;
